import { Button, HStack } from "@chakra-ui/react";

export const BlogPagination = ({ currentPage, totalPages, onPageChange }) => {
  const createPagination = () => {
    const pages = [];
    const delta = 2;

    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <HStack gap={4} justify="center" my={8}>
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        isDisabled={currentPage === 1}
        size="sm"
        borderRadius="md"
        py={4}
        minHeight={10}
      >
        Previous
      </Button>
      {createPagination().map((page) => (
        <Button
          key={page}
          variant={page === currentPage ? "solid" : "outline"}
          py={page === currentPage ? 4 : 4}
          bg={page === currentPage ? "green.700" : "white"}
          onClick={() => onPageChange(page)}
          size="sm"
          borderRadius="md"
          minHeight={10}
          px={4}
        >
          {page}
        </Button>
      ))}
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        isDisabled={currentPage === totalPages}
        size="sm"
        borderRadius="md"
        py={4}
        minHeight={10}
      >
        Next
      </Button>
    </HStack>
  );
};
